import React, { useContext, useEffect, useState } from "react";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import { Box, CircularProgress, Grid, useMediaQuery } from "@mui/material";
import Navbar from "../../../../posnavbar/Navbar";
import "./denomination.css";
import { UserContext } from "../../../../../../App";
import { useNavigate } from "react-router-dom";
import { eventMetricsData } from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import ProgressBar from "../../../../../../customComponents/PosCustomProgressBar/PosCustomProgressBar";
import {
  ArrowLongRightIcon,
  ClipboardDocumentListIcon,
  CurrencyDollarIcon,
  ShoppingCartIcon,
  TrashIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";

const DenominationV2 = () => {
  const navigate = useNavigate();
  const isMobileDevice = useMediaQuery(`(max-width: 576px)`);
  const showSnackbar = useSnackbar();

  const denominationArrayI = [
    {
      value: 500,
      count: 0,
      name: "500",
    },
    {
      value: 200,
      count: 0,
      name: "200",
    },
    {
      value: 100,
      count: 0,
      name: "100",
    },
    {
      value: 50,
      count: 0,
      name: "50",
    },
    {
      value: 20,
      count: 0,
      name: "20",
    },
    {
      value: 10,
      count: 0,
      name: "10",
    },
    {
      value: 5,
      count: 0,
      name: "5",
    },
    {
      value: 2,
      count: 0,
      name: "2",
    },
    {
      value: 1,
      count: 0,
      name: "1",
    },
  ];

  const [denominationArray, setDenominationArray] = useState(denominationArrayI);

  const [denomination, setDenominations] = useState(false);

  const [eventMetricData, setEventMetricData] = useState({
    CART_DELETED: null,
    CART_HOLD: null,
    CART_ITEM_REMOVED: null,
    ORDER_EDITED: null,
    ORDER_RECEIPT_REPRINT: null,
    LOYALTY_AWARDED: null,
    PAYMENT_MODE_CHANGE: null,
  });
  const [orderMetricData, setOrderMetricData] = useState({
    averageOrderTime: null,
    averageItemTime: null,
    manualSearchCount: null,
    barCodeSearchCount: null,
    totalItems: null,
    totalOrders: null,
  });
  const [metricDataLoader, setMetricDataLoader] = useState(false);

  const { totalAmountDen, setTotalamountDen } = useContext(UserContext);
  const { denoArr, setDenoArr } = useContext(UserContext);
  var totalAmt = 0;

  const calculateTotal = (() => {
    let total = 0;

    denominationArray.forEach((denomination) => {
      total += denomination?.value * denomination?.count;
    });

    totalAmt = total;
    return total;
  })();

  const handleClosedenomination = () => {
    setDenominations(false);
    navigate(-1);
  };

  const [totalAmountText, setTotalamountText] = useState(false);

  const handleProceeddenomination = () => {
    setDenominations(false);
    setTotalamountText(true);
    setTotalamountDen(calculateTotal);
    setDenoArr(denominationArray);
    navigate("/session-page/closing");
  };

  const handleChangequantity = (e, i) => {
    const newValue = e.replace(/\D/g, "");
    const newArr = [...denominationArray];
    newArr[i]["count"] = newValue;
    setDenominationArray(newArr);
  };

  //eventMetrics Data

  const fetchEventMetricsData = () => {
    setMetricDataLoader(true);
    const sessionId = localStorage.getItem("sessionId");
    eventMetricsData(sessionId)
      .then((res) => {
        if (res?.data?.es === 0) {
          const eventMetric = res?.data?.eventMetrics;
          const orderMetric = res?.data?.orderMetrics;
          setEventMetricData({
            CART_DELETED: eventMetric?.CART_DELETED,
            CART_HOLD: eventMetric?.CART_HOLD,
            CART_ITEM_REMOVED: eventMetric?.CART_ITEM_REMOVED,
            ORDER_EDITED: eventMetric?.ORDER_EDITED,
            ORDER_RECEIPT_REPRINT: eventMetric?.ORDER_RECEIPT_REPRINT,
            LOYALTY_AWARDED: eventMetric?.LOYALTY_AWARDED,
            PAYMENT_MODE_CHANGE: eventMetric?.PAYMENT_MODE_CHANGE,
          });
          setOrderMetricData({
            averageOrderTime: orderMetric?.averageOrderTime,
            averageItemTime: orderMetric?.averageItemTime,
            manualSearchCount: orderMetric?.manualSearchCount,
            barCodeSearchCount: orderMetric?.barCodeSearchCount,
            totalItems: orderMetric?.totalItems,
            totalOrders: orderMetric?.totalOrders,
          });
          setMetricDataLoader(false);
        } else {
          setMetricDataLoader(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.message || err?.data?.res?.message || "Something went wrong", "error");
        setMetricDataLoader(false);
      });
  };

  useEffect(() => {
    fetchEventMetricsData();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && totalAmt) {
        handleProceeddenomination();
      } else if (e.key === "Escape") {
        handleClosedenomination();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [totalAmt]);

  const eventMetricArray = [
    {
      eventName: "Cart Deleted",
      eventValue: "CART_DELETED",
    },
    {
      eventName: "Cart Hold",
      eventValue: "CART_HOLD",
    },
    {
      eventName: "Cart Item Removed",
      eventValue: "CART_ITEM_REMOVED",
    },

    {
      eventName: "Order Edited",
      eventValue: "ORDER_EDITED",
    },

    {
      eventName: "Order Receipt Reprint",
      eventValue: "ORDER_RECEIPT_REPRINT",
    },

    {
      eventName: "Loyalty Awarded",
      eventValue: "LOYALTY_AWARDED",
    },
    {
      eventName: "Payment Switch",
      eventValue: "PAYMENT_MODE_CHANGE",
    },
  ];

  const orderMetric = [
    { eventName: "Average Order Time", eventValue: "averageOrderTime" },
    { eventName: "Average Item Addition Time", eventValue: "averageItemTime" },
    { eventName: "Manually Added Product", eventValue: "manualSearchCount" },
    { eventName: "Scanned Product", eventValue: "barCodeSearchCount" },
    { eventName: "Total Products Added", eventValue: "totalItems" },
    { eventName: "Total Orders", eventValue: "totalOrders" },
  ];

  const orderMetricRow1 = [
    { eventName: "Average Order Time", eventValue: "averageOrderTime" },
    { eventName: "Average Item Addition Time", eventValue: "averageItemTime" },
    { eventName: "Manually Added Product", eventValue: "manualSearchCount" },
  ];

  const orderMetricRow2 = [
    { eventName: "Scanned Product", eventValue: "barCodeSearchCount" },
    { eventName: "Total Products Added", eventValue: "totalItems" },
    { eventName: "Total Orders", eventValue: "totalOrders" },
  ];

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 38 || e.keyCode === 40) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Navbar pageTitle={"Sessions"}>
      {/* new implementation */}
      <Box className="deno-parent-container">
        {/* progress bar and button section */}
        {/* <section className="deno-top-container-section">
          progressbar and label 
          <div className="progressbar-container-div">
           progressbar label part 
            <div className="progressbar-container-label-div">
              <p className="progressbar-label-p">Closing Sessions</p>
            </div>

             progress bar section 
             <div className="progress-bar-container">
              <ProgressBar percentage={50} progressBarHeight={"10px"} />
            </div>
          </div>

           cancel and save btn 
          <div className="cancel-save-btn-div">
            <PosCustomButton
              title="Back"
              p="8px 12px"
              height="40px"
              onClickFunction={handleClosedenomination}
            />

            <PosCustomButton
              title={"Submit"}
              variant="blue-d"
              radius="4px"
              p="8px 12px"
              height="40px"
              gap="8px"
              disabled={!totalAmt}
              onClickFunction={handleProceeddenomination}
              iconOnRight={
                <PosCustomIcon
                  icon={<ArrowLongRightIcon />}
                  height={"20px"}
                  width={"20px"}
                  color="var(--surface-white)"
                />
              }
            />
          </div>
        </section> */}

        {/* cart metrics title section */}
        {/* <section className="deno-cart-metrics-section">Cart Metrics</section> */}

        {/* cart metrics cards */}
        {/* <section className="deno-cart-metrics-card-container">
          {eventMetricArray?.map((el, idx) => {
            return (
              <div className="deno-cart-metrics-card" key={idx}>
                <div className="cart-metrics-card-inner-container-wrapper">
                   top label section 
                  <p className="inner-container-wrapper-label">{el?.eventName ?? ""}</p>

                   value section
                  <p className="inner-container-wrapper-value">
                    {eventMetricData?.[el?.eventValue] || "NA"}
                  </p>
                </div>
              </div>
            );
          })}
        </section> */}

        {/* event metrics title section */}
        {/* <section className="deno-event-metrics-section">Event Metrics</section> */}

        {/* event metrics cards section */}

        {/* <section className="event-metrics-card-wrapper">
         event metrics 1st row 
          <div className="event-metrics-card-row-1-container">
            {orderMetricRow1?.map((el, idx) => {
              return (
                // cards
                <div className="event-metrics-row-1-cards">
                 
                  <Box className="row-1-card-sub-container">
                    <p className="row-1-card-sub-container-p">{el?.eventName ?? ""}</p>
                  </Box>

                
                  <Box className="row-2-card-sub-container">
                    <p className="row-2-card-sub-container-p">
                      {el.eventValue === "averageOrderTime" ? (
                        <>
                          {orderMetricData?.[el?.eventValue] !== null
                            ? `${(orderMetricData?.[el?.eventValue] / 1000).toFixed(2)}s`
                            : "NA"}
                        </>
                      ) : el.eventValue === "averageItemTime" ? (
                        <>
                          {orderMetricData?.[el?.eventValue] !== null
                            ? `${(orderMetricData?.[el.eventValue]).toFixed(2)}ms`
                            : "NA"}
                        </>
                      ) : (
                        <>{orderMetricData?.[el?.eventValue] || "NA"}</>
                      )}
                    </p>
                  </Box>
                </div>
              );
            })}
          </div>

           event metrics 2nd row 
          <div className="event-metrics-card-row-1-container">
            {orderMetricRow2?.map((el, idx) => {
              return (
                // cards
                <div className="event-metrics-row-1-cards">
                 row1 
                  <Box className="row-1-card-sub-container">
                    <p className="row-1-card-sub-container-p">{el?.eventName ?? ""}</p>
                  </Box>

                   row 2 
                  <Box className="row-2-card-sub-container">
                    <p className="row-2-card-sub-container-p">
                      {el.eventValue === "averageOrderTime" ? (
                        <>
                          {orderMetricData?.[el?.eventValue] !== null
                            ? `${(orderMetricData?.[el?.eventValue] / 1000).toFixed(2)}s`
                            : "NA"}
                        </>
                      ) : el.eventValue === "averageItemTime" ? (
                        <>
                          {orderMetricData?.[el?.eventValue] !== null
                            ? `${(orderMetricData?.[el.eventValue]).toFixed(2)}ms`
                            : "NA"}
                        </>
                      ) : (
                        <>{orderMetricData?.[el?.eventValue] || "NA"}</>
                      )}
                    </p>
                  </Box>
                </div>
              );
            })}
          </div>
        </section> */}

        {/* denominations title section */}

        <section className="deno-denomination-section">Denominations</section>

        {/* denominations table and payment wrapper sections */}
        <section className="denomination-payment-section-wrapper">
          <div className="denominations-currency-select-container">
            <table className="new-deno-table">
              <tbody>
                <tr>
                  <th style={{ color: "#535862", fontSize: "12px", fontWeight: 500 }}>Note</th>
                  <th style={{ color: "#535862", fontSize: "12px", fontWeight: 500 }}>Count</th>
                </tr>

                {denominationArray &&
                  denominationArray.map((e, i) => (
                    <tr key={i} className="new-deno-text-wrapper">
                      <td>{e?.value}</td>
                      <td style={{ width: "50%" }}>
                        <input
                          className="denomination-input-new"
                          placeholder="Enter count"
                          type="number"
                          id="denomination"
                          value={e?.count}
                          onChange={(e) => handleChangequantity(e.target.value, i)}
                          onFocus={(e) => {
                            if (e.target.value === "0") {
                              e.target.value = "";
                            }
                          }}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              e.target.value = "0";
                            }
                          }}
                          onWheel={(e) => e.preventDefault()}
                          maxLength="10"
                          // onKeyDown={preventScroll}
                          // onWheel={handleWheel}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {/* left section box */}
            {/* <Box className="currency-select-container-left-box"></Box> */}

            {/* right section box */}
            {/* <Box className="currency-select-container-right-box"></Box> */}
          </div>

          {/* payment section */}
          <div className="denominations-payment-total-div">
            <p className="denominations-payment-total-div-p">Total Amount</p>

            <p className="denominations-payment-total-div-amount-p">
              {" "}
              {`\u20b9`} {calculateTotal}
            </p>
          </div>
        </section>
      </Box>

      {/* old implementation */}
      {/* <Box className="new-deno-container">
        <Grid container spacing={2}>
          {!isMobileDevice && (
            <Grid item xs={12} md={6}>
              <div className="new-deno-inner-container">
                <p className="new-deno-heading-text">Metrics Data</p>
                <div className="new-metric-data">
                  {metricDataLoader ? (
                    <Box className="metric-loader">
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <p>Events</p>
                      <table className="new-deno-table">
                        <tbody>
                          <tr>
                            <th>Sr. No</th>
                            <th>Event</th>
                            <th>Value</th>
                          </tr>
                          {eventMetricArray.map((event, index) => (
                            <tr className="new-deno-metrics-txt">
                              <td>{index + 1}</td>
                              <td>{event?.eventName}</td>
                              <td>{eventMetricData?.[event.eventValue] || "NA"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <p style={{ marginTop: "4px" }}>Order Metrics</p>
                      <table className="new-deno-table">
                        <tbody>
                          <tr>
                            <th>Sr. No</th>
                            <th>Event</th>
                            <th>Value</th>
                          </tr>
                          {orderMetric.map((orderEvent, index) => (
                            <tr className="new-deno-metrics-txt">
                              <td>{index + 1}</td>
                              <td>{orderEvent?.eventName}</td>
                              {orderEvent.eventValue === "averageOrderTime" ? (
                                <td>
                                  {orderMetricData?.[orderEvent?.eventValue] !== null
                                    ? `${(orderMetricData?.[orderEvent.eventValue] / 1000).toFixed(
                                        2
                                      )}s`
                                    : "NA"}
                                </td>
                              ) : orderEvent.eventValue === "averageItemTime" ? (
                                <td>
                                  {orderMetricData?.[orderEvent?.eventValue] !== null
                                    ? `${(orderMetricData?.[orderEvent.eventValue]).toFixed(2)}ms`
                                    : "NA"}
                                </td>
                              ) : (
                                <td>{orderMetricData?.[orderEvent.eventValue] || "NA"}</td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </div>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <div className="new-deno-inner-container">
              <p className="new-deno-heading-text">Denominations</p>
              <table className="new-deno-table">
                <tbody>
                  <tr>
                    <th>Note</th>
                    <th>Count</th>
                  </tr>

                  {denominationArray &&
                    denominationArray.map((e, i) => (
                      <tr key={i} className="new-deno-text-wrapper">
                        <td>{e?.value}</td>
                        <td>
                          <input
                            className="denomination-input-new"
                            placeholder="Enter count"
                            type="number"
                            id="denomination"
                            value={e?.count}
                            onChange={(e) => handleChangequantity(e.target.value, i)}
                            onFocus={(e) => {
                              if (e.target.value === "0") {
                                e.target.value = "";
                              }
                            }}
                            onBlur={(e) => {
                              if (e.target.value === "") {
                                e.target.value = "0";
                              }
                            }}
                            onWheel={(e) => e.preventDefault()}
                            maxLength="10"
                            // onKeyDown={preventScroll}
                            // onWheel={handleWheel}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="sum-wrapper-container">
                <h3>Total amount</h3>
                <h2 className="amount-text">
                  {`\u20b9`} {calculateTotal}
                </h2>
              </div>
              <div className="new-deno-action-buttons">
                <PosCustomButton
                  title="Cancel"
                  variant="red-transparent"
                  radius="4px"
                  p="12px 16px"
                  width="50%"
                  onClickFunction={handleClosedenomination}
                />
                <PosCustomButton
                  title={!totalAmt ? "Please enter an amount to proceed" : "Proceed"}
                  variant="blue-d"
                  radius="4px"
                  p="12px 16px"
                  width="100%"
                  // disabled={!totalAmt}
                  onClickFunction={handleProceeddenomination}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Box> */}
    </Navbar>
  );
};

export default DenominationV2;
